import type {MobileNavBarItem} from "../../model/types";
import {requestLogin, useIsAuthenticated} from "@/entities/session";
import {User} from "@/entities/user";
import {useProfileNavigation} from "@/features/profile-navigation";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {useCatalogMenu} from "@/widgets/catalog-menu";
import {useBasketStore} from "@/Stores/Site/Basket"; // Legacy

type Params = {
    user: User;
};

export const useMobileNavBar = (
    {
        user
    }: Params
) => {
    const basketCount = useBasketStore(state => state.basketCount);
    const openProfileNavigationModal = useProfileNavigation(s => s.actions.openModal);

    const catalogMenuDrawer = useCatalogMenu();
    const isAuthenticated = useIsAuthenticated();
    const {favouritesStore} = useStoreMobx();

    const activeOrders = user.ordersCount + user.refundsCount;

    return <MobileNavBarItem[]>[
        {
            id: "catalog",
            title: "Каталог",
            icon: "catalog",
            href: "/catalog",
            component: "button",
            onClick: catalogMenuDrawer.open,
        },
        {
            id: "profile",
            title: "Профиль",
            icon: "profile",
            svgClassName: "svgProfile",
            badge: isAuthenticated && activeOrders > 0,
            badgeClassName: "badgeProfile",
            href: "/home?profile=profile",
            component: "button",
            onClick: isAuthenticated ? openProfileNavigationModal : requestLogin,
        },
        {
            id: "main",
            icon: "main-logo-mobile",
            svgClassName: "svgLogo",
            href: "/",
            component: "link",
            onClick: undefined,
        },
        {
            id: "favorites",
            title: "Избранное",
            icon: "favoriteBorderOutlinedIcon",
            badge: favouritesStore.favouritesData.length > 0,
            badgeClassName: "badgeFavorites",
            href: "/favorites",
            component: "link",
            onClick: undefined,
        },
        {
            id: "basket",
            title: "Корзина",
            icon: "headerBasket",
            badge: basketCount || undefined,
            badgeClassName: "badgeBasket",
            href: "/basket",
            component: "basketButton",
            onClick: undefined,
        },
    ];
};
